// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"134":"chunk_layerswipe","142":"chunk_statsgrid","874":"chunk_maplegend"}[chunkId] + "/oskari.min.css";
};